<template>
  <div>
    <wizard-steps
      :current-step="1"
      :show-third-step="a.A_NOM_DE === 1"
      :show-single-title="page === 6"
    ></wizard-steps>
    <div class="alert-form-container">
      <b-row align-v="end">
        <b-col cols="12" md="4">
          <b-form-group
            label="Problemática"
            label-for="HVPR_ALERTA_TEMPRANA"
            :state="validateProblematic()"
            class="required"
            :invalid-feedback="fb.HVPR_ALERTA_TEMPRANA"
          >
            <b-select
              id="HVPR_ALERTA_TEMPRANA"
              v-model="a.HVPR_ALERTA_TEMPRANA"
              :options="problematics"
              :state="validateProblematic()"
              placeholder="Seleccionar..."
              @change="getFilteredRiskFactors"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="8">
          <b-form-group
            label="Factor de riesgo"
            label-for="FACTORES_RIESGO"
            :state="validateRiskFactors()"
            :invalid-feedback="fb.FACTORES_RIESGO"
          >
            <satmed-select
              id="FACTORES_RIESGO"
              v-model="a.FACTORES_RIESGO"
              :disabled="!a.HVPR_ALERTA_TEMPRANA"
              :options="riskFactors"
              :state="validateRiskFactors()"
            ></satmed-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            :state="vDescripcionAlerta()"
            :invalid-feedback="fb.DESCRIPCION_ALERTA"
            class="required"
          >
            <label for="DESCRIPCION_ALERTA">
              Describe de manera resumida, pero detallada, la situación de la alerta.
              <small>
                Recuerda también indicar el lugar y adjuntar el material probatorio en caso de
                tenerlo.
              </small>
            </label>
            <b-form-textarea
              rows="4"
              id="DESCRIPCION_ALERTA"
              :placeholder="placeHolderDetalleAlerta"
              :state="vDescripcionAlerta()"
              v-model="a.DESCRIPCION_ALERTA"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group
            label="Comuna donde reside la persona en riesgo"
            label-for="COMUNA"
            :state="validateCommunes()"
            class="required"
            :invalid-feedback="fb.COMUNA_ID"
          >
            <b-select
              id="COMUNA"
              v-model="a.COMUNA_ID"
              :options="communes"
              :state="validateCommunes()"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group
            label="Barrio donde reside la persona en riesgo"
            label-for="BARRIO"
            :state="validateNeighborhood()"
            class="required"
            :invalid-feedback="fb.BARRIO_ID"
          >
            <b-select
              id="BARRIO"
              v-model="a.BARRIO_ID"
              :options="filteredNeighborhoods"
              :state="validateNeighborhood()"
            ></b-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <input-direccion
            v-model="a.DIRECCION_ALERTA"
            label="Dirección donde ocurre la alerta"
            :state="vDireccionAlerta()"
            class="required"
            :invalid-feedback="fb.DIRECCION_ALERTA"
          ></input-direccion>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Punto de referencia para ubicar la dirección"
            label-for="PUNTO"
            :state="validateReferencePoint()"
            class="required"
            :invalid-feedback="fb.PUNTO_REFERENCIA"
          >
            <b-input
              id="PUNTO"
              v-model="a.PUNTO_REFERENCIA"
              :state="validateReferencePoint()"
              placeholder="Describa lugares cercanos"
            ></b-input>
          </b-form-group>
        </b-col>

        <b-col cols="12" v-if="a.id === null">
          <b-form-group
            label="Material probatorio"
            :invalidFeedback="fb.FILES"
            :state="vFiles()"
            label-for="nombre"
          >
            <template slot="label">
              Material probatorio:
              <fai
                v-b-popover.hover.top="popoverTexts.materialProbatorioPropio"
                :icon="['fa', 'info-circle']"
              />
            </template>
            <b-form-file
              multiple
              v-model="a.FILES"
              :accept="mimeType"
              :state="vFiles()"
              placeholder="Seleccionar..."
              drop-placeholder="Arrastre el archivo aquí..."
            >
              <template slot="file-name" slot-scope="{ names }">
                <template v-for="(filename, index) of names">
                  <b-badge variant="secondary" :key="index">{{ filename }}</b-badge>
                </template>
              </template>
            </b-form-file>
            <span class="field-help">Tipo de archivo: PDF, RAR, ZIP. Máx: 5MB.</span>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import InputDireccion from '@/components/InputDireccion.vue';
import { expresiones } from '@/assets/expresionesRegulares';
import WizardSteps from '@/components/UI/WizardSteps.vue';

const placeHolderDetalleAlerta = 'Describa la situación de alerta';
const popoverTexts = {
  materialProbatorioPropio:
    'Por favor adjunte la información que usted crea necesaria como prueba para'
    + ' documentar mucho mejor la alerta. Tenga en cuenta que se permiten los siguientes archivos: .jpg,'
    + ' .jpeg, .gif, .png, .doc, .pdf. Y estos no deben superar un peso máximo de archivo superior a 16 Mb',
};

export default {
  name: 'PaginaNombreDe',
  props: {
    page: Number,
  },
  data() {
    return {
      placeHolderDetalleAlerta,
      popoverTexts,
      fb: {
        HVPR_ALERTA_TEMPRANA: null,
        FACTORES_RIESGO: null,
        DESCRIPCION_ALERTA: null,
        LUGAR_ALERTA_OTRO: null,
        COMUNA_ID: null,
        BARRIO_ID: null,
        DIRECCION_ALERTA: null,
        PUNTO_REFERENCIA: null,
        FILES: null,
      },
      mimeTypeAllowed: [],
      maxSizePerFile: 0,
      formIsSubmitted: false,
      riskFactors: [],
    };
  },
  components: {
    WizardSteps,
    InputDireccion,
  },
  computed: {
    ...mapState({
      a: (state) => state.alerta.item,
      problematics: (state) => state.alerta.problematics,
      communes: (state) => state.alerta.comunas,
      neighborhoods: (state) => state.alerta.barrios,
      api: (state) => state.api,
    }),
    /** @returns {string} */
    mimeType() {
      return this.mimeTypeAllowed.join(',');
    },
    /** @return {Array} */
    filteredNeighborhoods() {
      const neighborhoods = this.neighborhoods.filter(
        (neighborhood) => neighborhood.COMUNA === this.a.COMUNA_ID || neighborhood.value === null,
      ).sort((a, b) => {
        if (b.value === null) {
          return 1;
        }
        if (a.text > b.text) {
          return 1;
        }
        if (a.text < b.text) {
          return -1;
        }
        return 0;
      });

      return neighborhoods.length > 1 ? neighborhoods : this.neighborhoods;
    },
  },
  methods: {
    ...mapMutations('alerta', []),
    validatePage() {
      if (
        this.validateProblematic()
        && this.validateRiskFactors()
        && this.vDescripcionAlerta()
        && this.validateCommunes()
        && this.validateNeighborhood()
        && this.validateReferencePoint()
        && this.vDireccionAlerta() !== false
        && this.vFiles() !== false
      ) {
        return true;
      }
      return false;
    },

    validateProblematic() {
      if (!this.a.HVPR_ALERTA_TEMPRANA && this.fb.HVPR_ALERTA_TEMPRANA === null) {
        return null;
      }

      if (!this.a.HVPR_ALERTA_TEMPRANA) {
        this.fb.HVPR_ALERTA_TEMPRANA = 'Debes seleccionar una problemática.';
        return false;
      }

      this.fb.HVPR_ALERTA_TEMPRANA = '';
      return true;
    },

    validateRiskFactors() {
      return true;
    },

    validateCommunes() {
      if (this.a.COMUNA_ID === null && this.fb.COMUNA_ID === null) {
        return null;
      }

      if (!this.a.COMUNA_ID) {
        this.fb.COMUNA_ID = 'Debes seleccionar una comuna.';
        return false;
      }

      this.fb.COMUNA_ID = '';
      return true;
    },

    validateNeighborhood() {
      if (this.a.BARRIO_ID === null && this.fb.BARRIO_ID === null) {
        return null;
      }

      if (!this.a.BARRIO_ID) {
        this.fb.BARRIO_ID = 'Debes seleccionar un barrio.';
        return false;
      }

      this.fb.BARRIO_ID = '';
      return true;
    },

    validateReferencePoint() {
      if (this.a.PUNTO_REFERENCIA === null && this.fb.PUNTO_REFERENCIA === null) {
        return null;
      }
      if (!this.a.PUNTO_REFERENCIA) {
        this.fb.PUNTO_REFERENCIA = 'Debes brindar un punto de referencia para la ubicación de la alerta.';
        return false;
      }
      if (!expresiones.alphanumeric.test(this.a.PUNTO_REFERENCIA)) {
        this.fb.PUNTO_REFERENCIA = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.a.PUNTO_REFERENCIA.length > 254) {
        this.fb.PUNTO_REFERENCIA = 'Por favor evite superar el máximo de 254 caracteres';
        return false;
      }
      this.fb.PUNTO_REFERENCIA = '';
      return true;
    },

    vDescripcionAlerta() {
      if (this.a.DESCRIPCION_ALERTA === null && this.fb.DESCRIPCION_ALERTA === null) {
        return null;
      }
      if (!this.a.DESCRIPCION_ALERTA) {
        this.fb.DESCRIPCION_ALERTA = 'Debes brindar una descripción completa de la situación de alerta.';
        return false;
      }
      if (!expresiones.alphanumeric.test(this.a.DESCRIPCION_ALERTA)) {
        this.fb.DESCRIPCION_ALERTA = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.a.DESCRIPCION_ALERTA.length > 600) {
        this.fb.DESCRIPCION_ALERTA = 'Por favor indique un número que no supere máximo 600 caracteres';
        return false;
      }
      this.fb.DESCRIPCION_ALERTA = '';
      return true;
    },
    vDireccionAlerta() {
      if (this.a.A_NOM_DE === 1) {
        return true;
      }
      if (this.a.DIRECCION_ALERTA === null) {
        return false;
      }
      if (!this.a.DIRECCION_ALERTA) {
        return false;
      }
      if (!expresiones.address.test(this.a.DIRECCION_ALERTA)) {
        this.fb.DIRECCION_ALERTA = 'Este campo solo permite caracteres alfanuméricos o los símbolos: Numeral (#), Guión medio (-)';
        return false;
      }
      if (this.a.DIRECCION_ALERTA.length > 150) {
        this.fb.DIRECCION_ALERTA = 'Por favor indique un número que no supere máximo 150 caracteres.';
        return false;
      }
      return true;
    },
    vFiles() {
      if (this.a.FILES.length === 0) {
        return null;
      }

      if (this.a.FILES.length > 3) {
        this.fb.FILES = 'Solo se permite un máximo de 3 archivos';
        return false;
      }

      if (this.a.FILES.filter((e) => e.size > this.maxSizePerFile).length) {
        const maxSize = Math.round((this.maxSizePerFile * 100) / 1024 / 1024) / 100;
        this.fb.FILES = `El tamaño máximo por archivo es de: ${maxSize} MB`;
        return false;
      }
      return true;
    },
    async getFilteredRiskFactors() {
      this.riskFactors = [];
      this.a.FACTORES_RIESGO = [];
      if (this.a.HVPR_ALERTA_TEMPRANA <= 0) {
        return;
      }
      const { data } = await this.api.get(
        `/utils/factores-riesgos-problematica/${this.a.HVPR_ALERTA_TEMPRANA}`,
      );
      if (data[0].FactoresRiesgos.length > 0) {
        this.riskFactors = data[0].FactoresRiesgos.map((item) => ({
          value: item.id,
          text: item.DESCRIPCION,
        }));
      }
    },
    async getMimeTypeAllowed() {
      try {
        const { data } = await this.api.get('utils/mime-type-allowed');
        this.mimeTypeAllowed = data;
      } catch (err) {
        let msg = 'Ocurrió un error intentando consultar los tipos de archivos permitidos para cargar';
        if (err.message) {
          msg = err.message;
        }
        this.$bvToast.toast(msg, {
          title: 'Error',
          variant: 'danger',
        });
      }
    },
    async getMaxSizePerFile() {
      try {
        const { data } = await this.api.get('utils/max-size-per-file');
        this.maxSizePerFile = data;
      } catch (err) {
        let msg = 'Ocurrió un error intentando consultar el tamaño máximo permitido por archivo';
        if (err.message) {
          msg = err.message;
        }
        this.$bvToast.toast(msg, {
          title: 'Error',
          variant: 'danger',
        });
      }
    },
  },
  watch: {
    files(val) {
      this.a.FILES = val.slice(0, 3);
    },
  },
  mounted() {
    this.getMimeTypeAllowed();
    this.getMaxSizePerFile();
  },
};
</script>

<style scoped>
.field-help {
  margin-top: 5px;
  font: normal normal normal 12px/15px Montserrat;
  letter-spacing: 0px;
  color: #1a1a1a;
}
label > small {
  font: normal normal normal 16px/15px Montserrat;
}
</style>
<style lang="scss">
.b-popover {
  max-width: 400px;
}
</style>
